module.exports = __webpack_public_path__ + "img/20191209170032801.3cf26553.jpg";